import classNames from 'classnames';

const SideTabs = (props) => {
	const { tabs, children, value, onChange } = props;

	return (
		<div className="sui-tabs sui-side-tabs">
			<div role="tablist" className="sui-tabs-menu">
				{Object.keys(tabs).map((tabKey) => {
					return (
						<button
							type="button"
							role="tab"
							aria-selected={value === tabKey ? 'true' : 'false'}
							className={classNames('sui-tab-item', {
								active: value === tabKey,
							})}
							key={tabKey}
							onClick={() => onChange(tabKey)}
						>
							{tabs[tabKey]}
						</button>
					);
				})}
			</div>

			{!!children && (
				<div className="sui-tabs-content">
					<div className="sui-tab-content active">
						<div className="sui-border-frame">{children}</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default SideTabs;
